import { render, staticRenderFns } from "./device_detail_slot_list.vue?vue&type=template&id=c2b058f2"
import script from "./device_detail_slot_list.vue?vue&type=script&lang=js"
export * from "./device_detail_slot_list.vue?vue&type=script&lang=js"
import style0 from "./device_detail_slot_list.vue?vue&type=style&index=0&id=c2b058f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports